import { useGetApStamplessContractsSuspenseInfinite as useBaseGetApStamplessContractsSuspenseInfinite } from 'ap-openapi';

type Params = {
  query?: string;
  per?: number;
};

export const useGetApStamplessContractsSuspenseInfinite = ({
  query,
  per,
}: Params) => {
  const { data, error, isLoading, hasNextPage, fetchNextPage } =
    useBaseGetApStamplessContractsSuspenseInfinite(
      {
        query,
        per,
      },
      {
        query: {
          getNextPageParam: (page) => {
            const url = new URL(page.data.next ?? '/', location.href);
            if (!url.searchParams.has('page')) return undefined;
            return Number(url.searchParams.get('page'));
          },
        },
      }
    );
  if (error) throw error;
  return { data, isLoading, hasNextPage, fetchNextPage };
};
